import React, { FC } from "react";
import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PenToSquare: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faPenToSquare} {...props} />
);
